import { ReactNode } from "react";

type PendingReportMetricProps = {
  className?: string;
  icon: ReactNode;
  iconVariant?: "danger" | "success" | "warning" | "info";
  label: ReactNode;
  value: ReactNode;
};

const PendingReportMetric = ({
  className,
  icon,
  iconVariant = "info",
  label,
  value,
}: PendingReportMetricProps) => {
  return (
    <div
      className={["d-flex gap-2 align-items-start", className]
        .filter(Boolean)
        .join(" ")}
    >
      <span
        className={`cle-afventende-indberetninger-card__icon-wrap cle-afventende-indberetninger-card__icon-wrap--${iconVariant} d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3`}
        aria-hidden="true"
      >
        {icon}
      </span>
      <div className="min-w-0">
        <p className="cle-afventende-indberetninger-card__muted cle-afventende-indberetninger-card__meta-line mb-0">
          {label}
        </p>
        <p className="cle-afventende-indberetninger-card__value mb-0 fw-bold">
          {value}{" "}
        </p>
      </div>
    </div>
  );
};

export default PendingReportMetric;
